import {
    Component, computed, effect,
    ElementRef,
    HostListener,
    inject,
    input, Input,
    OnDestroy,
    OnInit, signal, untracked,
    ViewChild,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Params, Router, RouterOutlet } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from '../app.service';
import { PhitoUser } from '../../phito-models/phito-user';
import { NotificationService } from '../../services/notification.service';
import { Observable, Subscription } from 'rxjs';
import { catchError, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { BackendApiService } from '../../services/backend-api.service';
import { PhitoSession } from '../../services/phito-session';
import { Phitom } from '../../components/phitom-tree-new/phitom';
import { PhitoSessionService } from '../../services/phito-session.service';
import { PhitomTreeNewService } from '../../components/phitom-tree-new/phitom-tree-new.service';
import { ROUTES_WITHOUT_TOOLBAR } from '../../phito-core.config';
import { MainMenuConfig } from './main-menu';
import { MainMenuItemService } from './main-menu-item/main-menu-item.service';
import { PasswortDialogComponent } from '../../dialogs/passwort-dialog/passwort-dialog.component';
import { RenewPasswordDialogResult } from '../../dialogs/passwort-dialog/classes/renew-password-dialog-result';
import { NavigateDialogComponent } from './navigate-dialog/navigate-dialog.component';
import { PermissionAction } from '../../modules/administration/role-and-permissions/role-and-permission';
import { MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { MatProgressBar } from '@angular/material/progress-bar';
import {
    NotificationCenterComponent
} from '../../components/notification-center/notification-center/notification-center.component';
import { MatFabButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AppLogoComponent } from './app-logo/app-logo.component';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { GrowOnFocusDirective } from '../../directives/grow-on-focus/grow-on-focus.directive';
import { MatOption } from '@angular/material/select';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatTooltip } from '@angular/material/tooltip';
import { PhitomTreeNewComponent } from '../../components/phitom-tree-new/phitom-tree-new/phitom-tree-new.component';
import {
    NotificationCenterButtonComponent
} from '../../components/notification-center/notification-center-button/notification-center-button.component';
import {
    TodoQuickEntryOverlayComponent
} from '../../modules/todo/todo-quick-entry-overlay/todo-quick-entry-overlay.component';
import { ProfileButtonComponent } from '../../modules/user-settings/profile-button/profile-button.component';
import { FavoriteMenuButtonComponent } from '../favorites/favorite-menu-button/favorite-menu-button.component';
import { AsyncPipe, CommonModule, NgClass } from '@angular/common';
import { MainMenuItemComponent } from './main-menu-item/main-menu-item.component';
import { PhitoAppOptions, RequestProgress } from './phito-app';
import { ChangePasswordData, ChangePasswortOptions } from '../../dialogs/passwort-dialog/classes/change-password-pojo';
import { PhitoThemeService } from '../../services/phito-theme.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { DocumentationService } from '../../modules/documentation/documentation.service';
import { TICKET_ROUTES } from '../../modules/tickets/ticket.routes';
import { RouterService } from '../../services/router.service';

@Component({
    selector: 'phito-app',
    templateUrl: './phito-app.component.html',
    styleUrls: ['./phito-app.component.scss'],
    imports: [
        CommonModule,
        MatSidenavContainer,
        MatSidenavContent,
        MatProgressBar,
        NotificationCenterComponent,
        MatFabButton,
        MatIcon,
        AppLogoComponent,
        MatIconButton,
        CdkOverlayOrigin,
        FormsModule,
        MatAutocompleteTrigger,
        GrowOnFocusDirective,
        ReactiveFormsModule,
        MatAutocomplete,
        MatOption,
        CdkConnectedOverlay,
        CdkDrag,
        CdkDragHandle,
        MatTooltip,
        PhitomTreeNewComponent,
        NotificationCenterButtonComponent,
        TodoQuickEntryOverlayComponent,
        ProfileButtonComponent,
        FavoriteMenuButtonComponent,
        NgClass,
        MainMenuItemComponent,
        RouterOutlet,
        AsyncPipe,
    ],
})
export class PhitoAppComponent implements OnInit, OnDestroy {
    protected appService = inject(AppService);
    private routerService = inject(RouterService);
    private route = inject(ActivatedRoute);
    protected phitoSessionService = inject(PhitoSessionService);
    //private cdR = inject(ChangeDetectorRef);
    dialog = inject(MatDialog);
    protected phitomTreeService = inject(PhitomTreeNewService);
    private notificationService = inject(NotificationService);
    private api = inject(BackendApiService);
    private mainMenuItemService = inject(MainMenuItemService);
    private themeService = inject(PhitoThemeService);
    private routesWithoutToolbar = inject(ROUTES_WITHOUT_TOOLBAR, { optional: true });
    private documentationService = inject(DocumentationService);

    logoHexId = input<string>();
    @Input('logo') logo: any;
    @Input('logoklein') logoklein: any;
    @Input('logoWidth') logoWidth: string;
    @Input('screenBlockLoaderHeight') screenBlockLoaderHeight = '100vh';
    @Input('screenBlockLoaderWidth') screenBlockLoaderWidth = '100vw';
    @Input('screenBlockLoaderText') screenBlockLoaderText = 'Lade Daten';
    mainMenuConfig = input<MainMenuConfig>();
    @Input('options') options: PhitoAppOptions;
    @Input() showTodoQuickEntry = false;
    @ViewChild('phitomTreeOverlay') phitomTreeOverlay: ElementRef;

    searchCtrl = new FormControl();
    phitomTreeDragging = false;
    showHierachy = false;
    currentYear: number = new Date().getFullYear();
    currentPhitom?: Phitom;
    phitomTreeAddDialogOpen = false;
    @ViewChild('sidenav') sidenav: ElementRef | undefined;
    dialogRef: MatDialogRef<PasswortDialogComponent> = undefined;
    phitomTreeSub: Subscription;

    requestProgressSub: Subscription;
    requestProgressPercent = 0;

    phitomAutocompleteCtrl = new FormControl();

    hasTicketPermission = false;
    hasNotificationPermission = false;
    hasAiChatPermission = false;
    hasTodoPermission = false;
    hasFavoriteFilterPermission = false;

    searchedPhitoms: Observable<Phitom[]>;

    @Input('logoFileSuffix') logoFileSuffix = 'jpeg';

    showFullScreenCancelButton = signal(false);

    readonly viewMode = signal<string>(null);

    showFullScreen = computed(() => {
        const viewMode2 = this.viewMode();
        const showFullScreen2 = untracked(() => this.appService.showFullscreen());
        return showFullScreen2 || viewMode2 === 'fullscreen';
    });

    showToolbar = computed(() => {
        return !this.showFullScreen() &&
            this.phitoSessionService.phitoSession() &&
            !this.routesWithoutToolbar?.some((route) => this.phitoSessionService.currentUrl()?.includes(route.toString()))
    });

    showSidenav = computed(() => {
        if (!this.phitoSessionService.phitoSession() || this.showFullScreen()) {
            return false;
        }
        if (this.appService.isMobile()) {
            return this.appService.sideNavVisible();
        } else if (this.appService.isTablet()) {
            return !this.appService.isPortrait() || this.appService.sideNavVisible();
        } else {
            return true;
        }
    });

    showPhitomTree = computed(() => {
        return this.phitoSessionService.phitoSession() && !this.showFullScreen();
    })

    constructor() {
        void this.themeService;

        effect(() => {
            if (this.phitoSessionService.loggedIn() && this.phitoSessionService.phitoSession()) {
                this.checkPassword(this.phitoSessionService.phitoSession());
            }
        });

        effect(() => {
            this.phitomTreeService.currentPhitom()
            this.phitomAutocompleteCtrl.setValue('', { emitEvent: false });
        });

        effect(() => {
            const mmc = this.mainMenuConfig();
            this.appService.mainMenuConfig.set(mmc);
        });
    }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.altKey && event.code === 'KeyN') {
            event.preventDefault();
            this.dialog.open(NavigateDialogComponent, {
                data: this.mainMenuConfig()?.getMainMenuItems(),
                width: '50%'
            });
        }
    }

    ngOnDestroy(): void {
        this.phitomTreeSub?.unsubscribe();
        this.requestProgressSub?.unsubscribe();
    }

    ngOnInit() {
        this.route.queryParamMap.subscribe(params => {
            const vm: string = params.get('viewMode')?.toLowerCase();
            this.viewMode.set(vm);
        });

        this.hasTicketPermission = this.phitoSessionService.hasPermission(
            PermissionAction.Ansehen('Ticket', 'Ticket'),
            'PhitoAppComponent',
        );
        this.hasNotificationPermission = this.phitoSessionService.hasPermission(
            PermissionAction.Ansehen('System', 'Notification'),
            'PhitoAppComponent',
        );
        this.hasAiChatPermission = this.phitoSessionService.hasPermission(
            PermissionAction.Ansehen('AI', 'Conversations'),
            'PhitoAppComponent',
        );
        this.hasTodoPermission = this.phitoSessionService.hasPermission(
            PermissionAction.Ansehen('Todo', 'Todo'),
            'PhitoAppComponent',
        );
        this.hasFavoriteFilterPermission = this.phitoSessionService.hasPermission(
            new PermissionAction('System', 'Filter', 'Favoriten ansehen'),
            'PhitoAppComponent',
        );
        this.requestProgressSub = this.api.watchRequestProgress().subscribe({
            next: (rp: RequestProgress) => {
                if (rp?.targetValue > 0 && rp.currentValue < rp.targetValue) {
                    this.requestProgressPercent = (rp.currentValue / rp.targetValue) * 100;
                } else {
                    this.requestProgressPercent = 0;
                }
            },
        });

        this.autocompletePhitomSearch();
    }

    toggleSidenav() {
        this.appService.sideNavVisible.set(!this.showSidenav())
    }

    isActiveRouteFavorite() {
        return this.mainMenuItemService.isActiveRouteString(['/favorite']);
    }

    autocompletePhitomSearch() {
        this.searchedPhitoms = this.phitomAutocompleteCtrl.valueChanges.pipe(
            startWith(''),
            distinctUntilChanged(),
            switchMap((value) => {
                return this.searchPhitomAutocomplete(value);
            }),
        );
    }

    searchPhitomAutocomplete(value: string, sender?: string) {
        let params = new HttpParams();
        if (value) {
            params = params.append('search', value ? value : '');
        }
        params = params.append('limit', '30');

        return this.api.getAll('phitom', params).pipe(
            map((response) => {
                return response.data;
            }),
            catchError((error) => {
                return [];
            }),
        );
    }

    phitomMapper(phitom: Phitom): string {
        if (phitom) {
            return phitom.nameExtended ? phitom.nameExtended : phitom.name;
        }
        return '';
    }

    @HostListener('window:keyup', ['$event'])
    toggleHierachyByF9(event: KeyboardEvent) {
        if (this.options?.hasPhitomHierachy === true && event.key === 'F9') {
            this.toggleHierachy();
        }
    }

    toggleHierachy() {
        this.showHierachy = !this.showHierachy;
    }

    openRenewPasswordDialog(user: PhitoUser) {
        const opt = new ChangePasswortOptions();
        opt.user = user;
        const cpd = new ChangePasswordData(true, opt);
        cpd.title = 'Passwort ändern';
        cpd.hint = 'Bitte geben Sie ein neues Passwort ein.';

        this.dialogRef = this.dialog.open(PasswortDialogComponent, {
            data: cpd
        });

        this.dialogRef.afterClosed().subscribe((resp: RenewPasswordDialogResult) => {
            if (resp) {
                this.notificationService.infoMessage(
                    'Das Passwort wurde erfolgreich aktualisiert. Bitte erneut mit dem neuen Passwort anmelden.',
                );
                this.phitoSessionService.sessionAktualisieren(true);
            } else {
                this.checkPassword(this.phitoSessionService.phitoSession());
            }
        });
    }

    exitFullScreen() {
        this.routerService.changeQueryParams({ viewMode: null }).then();
    }

    public selectedPhitom(phitom: Phitom) {
        this.showHierachy = false;
    }

    setSelectedPhitom(p: Phitom) {
        this.phitomTreeService.setCurrentPhitom(p);
    }

    private checkPassword(session: PhitoSession) {
        if (session?.user?.renewPassword === true) {
            this.openRenewPasswordDialog(session.user);
        }
    }

    navigated() {
        if (this.appService.isMobile()) {
            this.appService.sideNavVisible.set(false);
        }
    }

    goToTickets() {
        this.routerService.nav(TICKET_ROUTES.overview);
    }

    openAiChat() {
        this.documentationService.openAiChatSimple();
    }

}
